import styled, { keyframes } from 'styled-components';
import * as HoverCardPrimitive from '@radix-ui/react-hover-card';

const slideUpAndFade = keyframes`
  0% { opacity: 0; transform: translateY(2px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const slideRightAndFade = keyframes`
  0% { opacity: 0; transform: translateX(-2px); }
  100% { opacity: 1; transform: translateX(0); }
`;

const slideDownAndFade = keyframes`
  0% { opacity: 0; transform: translateY(-2px); }
  100% { opacity: 1; transform: translateY(0); }
`;

const slideLeftAndFade = keyframes`
  0% { opacity: 0; transform: translateX(2px); }
  100% { opacity: 1; transform: translateX(0); }
`;

export const HoverCardPrimitiveContent = styled(HoverCardPrimitive.Content)`
  border-radius: 6px;
  padding: 20px;
  background-color: ${props => props.theme.colors.card};

  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,
              hsl(206 22% 7% / 20%) 0px 10px 20px -15px;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;

  &[data-side="top"] { animation-name: ${slideDownAndFade}; }
  &[data-side="right"] { animation-name: ${slideLeftAndFade}; }
  &[data-side="bottom"] { animation-name: ${slideUpAndFade}; }
  &[data-side="left"] { animation-name: ${slideRightAndFade}; }
`;

export const HoverCardArrow = styled(HoverCardPrimitive.Arrow)`
  fill: white;
`;